import { cn } from '@poseidon/components/cn';

import { Button } from '@poseidon/components/Input2';
import { Arrows } from '@poseidon/components/StrokeIcons';

import { Kbd } from '@poseidon/components/Kbd';
import { LogoIcon, LogoText } from '~/components/ToneIcons';

type LogoRowProps = {
  navMinimized: boolean;
  setNavMinimized: (newValue: boolean | null) => void;
  // Passed in (rather than read from `navigator` here) so this row renders
  // purely from props.
  isMac: boolean;
};
export const LogoRow = ({ navMinimized, setNavMinimized, isMac }: LogoRowProps) => {
  return (
    <div className="flex flex-row items-center gap-4 px-5 pb-6 pl-6 pt-8">
      <span className="flex size-8 shrink-0 items-center justify-center">
        <LogoIcon />
      </span>
      <span
        className={cn(
          'h-8 whitespace-pre transition-opacity duration-200 ease-[cubic-bezier(0.05,0.61,0.41,0.95)]',
          navMinimized && 'opacity-0',
        )}>
        <LogoText className="h-full" />
      </span>

      <Button
        className={cn('absolute right-0 transition-transform duration-200', navMinimized && 'rotate-180')}
        text
        icon={<Arrows.ChevronLeftDouble />}
        tooltip={
          navMinimized ? (
            <span>
              Expand <Kbd>{isMac ? '⌘' : 'ctrl'}+B</Kbd>
            </span>
          ) : (
            <span>
              Minimize <Kbd>{isMac ? '⌘' : 'ctrl'}+B</Kbd>
            </span>
          )
        }
        onClick={() => setNavMinimized(!navMinimized)}
      />
    </div>
  );
};
